import type { GetWalletResponse } from '@dynamic-labs-wallet/browser-wallet-client';

import { getDefaultClient } from '../../../client/defaultClient';
import type { WalletAccount } from '../../wallets/walletAccount';
import { getWaasWalletProviderFromWalletAccount } from '../getWaasWalletProviderFromWalletAccount';

type UnlockWalletParams = {
  password: string;
  walletAccount: WalletAccount;
};

/**
 * Unlocks a WaaS wallet account.
 *
 * @param params.walletAccount - The WaaS wallet account to unlock.
 * @param params.password - The password to unlock the wallet.
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns A promise that resolves with the wallet information.
 */
export const unlockWallet = async (
  { password, walletAccount }: UnlockWalletParams,
  client = getDefaultClient()
): Promise<GetWalletResponse> => {
  const provider = getWaasWalletProviderFromWalletAccount(
    { walletAccount },
    client
  );

  return provider.unlockWallet({
    password,
    walletAccount,
  });
};
